import { createSlice } from '@reduxjs/toolkit';
import {
  deleteTradeReferenceExtraReducer,
  getTradeReferencesExtraReducer,
  updateTradeReferenceExtraReducer,
} from '../reducers/tradeReferenceReducers';
import { TradeReference } from '@dill/dill-shared';

export interface TradeReferenceInitialState {
  loadingList: string[];
  tradeReferences: TradeReference[];
}

const initialState: TradeReferenceInitialState = {
  loadingList: [],
  tradeReferences: [],
};

export const tradeReferencesSlice = createSlice({
  name: 'tradeReferences',
  initialState,
  reducers: {
    resetTradeReferenceState: () => initialState,
  },
  extraReducers(builder) {
    getTradeReferencesExtraReducer(builder);
    updateTradeReferenceExtraReducer(builder);
    deleteTradeReferenceExtraReducer(builder);
  },
});

export const { resetTradeReferenceState } = tradeReferencesSlice.actions;
